var map = {
	"./fivestar_en.png": "hBU1",
	"./fivestar_esp.png": "C2Gp",
	"./fivestar_th.png": "WTyc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tC18";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas ^\.\/fivestar_.*\.png$
// module id = tC18
// module chunks = 1